import { ProtocolSettings } from "./ProtocolSettings";
import { ProtocolSettingsTypes } from "./ProtocolSettingsTypes";
import { ObjUtils } from "../Utils/ObjUtils";
import { ValueEncoder } from "../Utils";

export class WindowsSettings extends ProtocolSettings {

	public UserName: string;
	public Password: string;
	public UsePowerShell: boolean;

	constructor() {
		super();

		this.UserName = "";
		this.Password = "";
		this.UsePowerShell = false;
	}

	public get Domain(): string {
		let winDomain = "";

		if (this.HasUserName) {
			let index: number = this.UserName.indexOf('\\');
			if (index > 0) {
				winDomain = this.UserName.substr(0, index);
				if (winDomain === ".")
					winDomain = "";
			}
		}

		return winDomain;
	}

	public get UserName_NoDomain(): string {
		let wmiUsername = "";

		if (this.HasUserName) {
			if (!this.HasDomain) {
				wmiUsername = this.UserName;
			}
			else {
				let index: number = this.UserName.indexOf('\\');
				if (index > 0) {
					index++; // Step over domain seperator
					wmiUsername = this.UserName.substr(index);
				}
			}
		}

		return wmiUsername;
	}

	public get HasDomain(): boolean {
		return !!this.Domain;
	}

	public get HasUserName(): boolean {
		return !!this.UserName;
	}

	public get HasPassword(): boolean {
		return !!this.Password;
	}

	public get SettingsType(): string {
		return ProtocolSettingsTypes.Windows;
	}

	public get Summary(): string {
		return `Username: ${this.UserName}`;
	}

	public Copy(obj: ProtocolSettings): void {
		if (!(obj instanceof WindowsSettings))
			return;
		let other = (obj as WindowsSettings);

		super.Copy(obj);

		this.UserName = "";
		if (other.HasUserName)
			this.UserName = other.UserName;

		this.Password = "";
		if (other.HasPassword)
			this.Password = other.Password;

		this.UsePowerShell = other.UsePowerShell;
	}

	public Clone(): ProtocolSettings {
		let clone = new WindowsSettings();
		clone.Copy(this);
		return clone;
	}

	public Equals(obj: any): boolean {
		if (!super.Equals(obj))
			return false;

		if (!(obj instanceof WindowsSettings))
			return false;
		let other: WindowsSettings = (obj as WindowsSettings);

		return (ObjUtils.Equals(this.UserName, other.UserName) &&
			ObjUtils.Equals(this.Password, other.Password) &&
			ObjUtils.Equals(this.UsePowerShell, other.UsePowerShell));
	}

	public Write(obj: any, context: any): void {
		obj.windows = {};
		obj = obj.windows;

		super.Write(obj, context);

		if (this.HasUserName)
			obj.user_name = this.UserName;

		if (this.HasPassword)
			obj.password = this.Password;

		obj.use_powershell = ValueEncoder.EncodeBoolean(this.UsePowerShell);
	}

	public Read(obj: any, context: any): void {
		if (!obj.windows)
			throw new Error();
		obj = obj.windows;

		super.Read(obj, context);

		if (obj.user_name !== undefined)
			this.UserName = obj.user_name;

		if (obj.password !== undefined)
			this.Password = obj.password;

		if (obj.use_powershell !== undefined)
			this.UsePowerShell = ValueEncoder.DecodeBoolean(obj.use_powershell);
	}

}

